/**
 * @import internal modules
 */

/**
 * @import external modules
 */

import * as React from 'react';
import { pure } from 'recompose';
import * as cx from 'classnames';

// component
const Component: React.FunctionComponent<any> = (
    props: InterfaceModal<string>,
): JSX.Element => {
    const { onClose, helping } = props;

    return (
        <div
            onClick={onClose}
            className={cx('modal-help', { 'modal-open': helping })}>
            <div className="modale-helping2 " />
        </div>
    );
};
// interface
export interface InterfaceModal<T> {
    items?: T;
    onClose?: any;
    helping?: boolean;
    onDropFile?: any;
}
/**
 * DefaultProps values
 */
Component.defaultProps = {};

export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/components/@widgets/helping/component.tsx